import gql from 'graphql-tag';

export const GET_USERS = gql`
  query searchCustomers(
    $search: String!
    $page: Int!
    $limit: Int
    $filters: [Boolean]
  ) {
    searchCustomers(
      search: $search
      page: $page
      limit: $limit
      filters: $filters
    ) {
      page
      totalPages
      hasNextPage
      hasPrevPage
      docs {
        customerId
        name
        email
        access
        designation
        isActive
      }
    }
  }
`;
